var exports = {
  "Sl": "xdbfd91f1--eee977--image",
  "iq": "xdbfd91f1--eee977--image-container",
  "DW": "xdbfd91f1--eee977--video_play",
};

module.exports = exports;
